<script>
export default {
  name: 'ClaimDate',
  props: {
    label: {
      type: String,
      default: 'Title',
    },
    percent: {
      type: String,
      default: '10',
    },
    date: {
      type: String,
      default: 'dd.mm.yyyy',
    },
    transaction: {
      type: String,
      default: '#',
    },
    passed: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<template>
  <div class="claim-date">
    <div class="claim-date__percent btn" :class="{ 'claim-date__percent--disabled': !passed }">
      {{ percent }}%
    </div>
    <p class="claim-date__label">{{ label }}</p>
    <p class="claim-date__date">{{ date }}</p>
    <div class="claim-date__checkbox" :class="{ 'claim-date__checkbox--passed': passed }"></div>
  </div>
</template>

<style lang="scss" scoped>
.claim-date {
  margin-bottom: 5rem;

  &__percent {
    width: 4rem;
    height: 4rem;
    border-radius: 4rem;
    padding: 0 !important;
    font-size: 1.2rem;
    line-height: 4rem;
    margin-bottom: 1rem;

    &--disabled {
      opacity: 0.8;

      body.binance & {
        background: $b-btn-bg-disabled;
        box-shadow: $b-btn-shadow-disabled;
        color: #fff;
      }
    }
  }

  p {
    color: #7478a0;
    font-size: 1.6rem;
    font-weight: bold;
    margin-bottom: 0.2rem;
  }

  a {
    text-decoration: none;
    font-size: 1.4rem;
    font-weight: normal;
    color: #7478a0;
  }

  &__checkbox {
    width: 2.4rem;
    height: 2.4rem;
    border-radius: 0.6rem;
    margin: 0.5rem auto;
    background: linear-gradient(103.94deg, #fdfafb -1.71%, #f7fbfc 45.51%);
    box-shadow: 5px 5px 10px rgba(255, 255, 255, 0.9), -1px -1px 5px rgba(182, 169, 173, 0.3),
      inset -2px -2px 2px rgba(182, 169, 173, 0.2), inset 1px 1px 4px rgba(182, 169, 173, 0.2),
      inset -2px -2px 4px rgba(255, 255, 255, 0.9), inset 1px 1px 2px rgba(182, 169, 173, 0.2);

    body.binance & {
      background: linear-gradient(180deg, #333344 0%, #2b2b3d 100%);
      color: $b-dark-font-color;
      box-shadow: none;
    }

    &--passed {
      box-shadow: none;
      background: url('../../assets/img/ethereum/check.svg') no-repeat center
        center / 1.6rem, #283287;

      body.binance & {
        background: url('../../assets/img/binance/check.svg') no-repeat center
          center / 1.6rem, linear-gradient(180deg, #fff177 0%, #fae744 100%);
        color: $b-dark-font-color;
      }
    }
  }
}
</style>
